import type { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';

import type { MagicWallCard, Sorts, WallResponse } from '@shared/api/types/magicWall';
import { TabsID } from '@shared/api/types/magicWall';

import MagicOrderWallActivity from '../MagicOrderWallActivity';
import MagicOrderWallOffersPage from '../MagicOrderWallOffersPage';

export type Tabs = {
  id: keyof typeof TabsID;
  label: string;
  Component: React.ComponentType<{
    query: UseInfiniteQueryResult<InfiniteData<WallResponse, unknown>, unknown>;
    list: MagicWallCard[];
    sort: Sorts;
    setSort: (value: Sorts) => void;
    categoryFilter: string;
    setCategoryFilter: (value: string) => void;
  }>;
};

export const tabs: Array<Tabs> = [
  {
    id: TabsID.Tasks,
    label: 'Tasks',
    Component: MagicOrderWallOffersPage,
  },
  {
    id: TabsID.Activity,
    label: 'Activity',
    Component: MagicOrderWallActivity,
  },
];
